function convertToSnakeCase(input){
    return input
        .toLowerCase()            
        .replace(/\s+/g, '_');    
  }

export default convertToSnakeCase

  


// WEBPACK FOOTER //
// ./src/utils/conertSnakeFormat.js